import * as Sentry from "@sentry/react";
import config from "devextreme/core/config";
import { StrictMode, useEffect } from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import {
	BrowserRouter,
	createRoutesFromChildren,
	matchRoutes,
	useLocation,
	useNavigationType,
} from "react-router-dom";
import App from "./App";
import { licenseKey } from "./devextreme-license";
import "./i18n/i18n";
import store from "./store";

const rootElement = document.getElementById("root");

if (!rootElement) {
	throw new Error("Failed to find the root element");
}

config({
	licenseKey,
});

const environment = import.meta.env.MODE;

// Solo inicializar Sentry si NO estamos en desarrollo local
if (environment !== "development" && environment !== "dev") {
	const getEnvironment = () => {
		const mode = import.meta.env.MODE;

		switch (mode) {
			case "pre":
				return "pre-production";
			case "test":
				return "testing";
			case "prod":
				return "production";
			default:
				return mode;
		}
	};

	Sentry.init({
		dsn: import.meta.env.VITE_SENTRY_DSN,
		integrations: [
			Sentry.reactRouterV6BrowserTracingIntegration({
				useEffect,
				useLocation,
				useNavigationType,
				createRoutesFromChildren,
				matchRoutes,
			}),
		],
		environment: getEnvironment(),
		tracePropagationTargets: [/^\//],
		tracesSampleRate: 1.0,
		replaysSessionSampleRate: 0.1,
		replaysOnErrorSampleRate: 1.0,
		release: `wisephere-web@${import.meta.env.VITE_APP_VERSION}` || "1.0.0",
	});
}

const root = ReactDOM.createRoot(rootElement);
root.render(
	<StrictMode>
		<BrowserRouter>
			<Provider store={store}>
				<App />
			</Provider>
		</BrowserRouter>
	</StrictMode>,
);
